export default {
  get: (index: string, defaultValue: any) => {
    const value = localStorage.getItem(index);
    if (value == null) return defaultValue;

    try {
      return JSON.parse(value);
    } catch (_) {
      return value;
    }
  },
  set: (index: string, value: any) => {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(index, value);
  },
  remove: (index: string) => {
    localStorage.removeItem(index);
  },
  clear: () => {
    localStorage.clear();
  },
};
